import '../config/sentry-boot';

import React from 'react';
import { render } from 'react-dom';
import MainApp from './MainApp';
import { initRemoteConfig } from './common/utils/firebase/remoteConfig';
import { setupGTM } from '../config/tagManager';
import { setupAmplitude } from '../config/amplitude';

const container = document.getElementById('root');

function initializeConfigs() {
  setupGTM();
  setupAmplitude();
}

async function initializeAsyncConfigs() {
  try {
    await initRemoteConfig();
  } catch (e) {
    console.warn('ATENÇÃO!!! Erro ao carregar remote config. Erro:', e);
  }
}

function renderApp() {
  render(<MainApp />, container);
}

async function startApplication() {
  initializeConfigs();
  await initializeAsyncConfigs();
  renderApp();
}

startApplication();
